import { useEffect, useState } from 'react';

// One breakpoint, shared with the stylesheet: at 900px the shell grows its
// sidebar and the two-pane workspaces switch on.
export function useIsDesktop(): boolean {
  const [wide, setWide] = useState(() => window.matchMedia('(min-width: 900px)').matches);
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 900px)');
    const on = (e: MediaQueryListEvent) => setWide(e.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return wide;
}
